<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-update-password-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'UpdatePassword',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreUpdatePasswordView: () => import('../components/core/UpdatePasswordView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>